var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeotechnicalMaterialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.75,
    height: 30.75,
    viewBox: "0 0 30.75 30.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_5",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11861",
    "data-name": "Path 11861",
    d: "M14,12v7.687a1.1,1.1,0,0,0,.116.491l1.1,2.2a1.1,1.1,0,0,0,1.965,0l1.1-2.2a1.1,1.1,0,0,0,.116-.491V12H14Z",
    transform: "translate(1.179 0.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11862",
    "data-name": "Path 11862",
    d: "M19.687,2H13.1A1.1,1.1,0,0,0,12,3.1v7.687a1.1,1.1,0,0,0,1.1,1.1h6.589a1.1,1.1,0,0,0,1.1-1.1V3.1A1.1,1.1,0,0,0,19.687,2Z",
    transform: "translate(0.982 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11863",
    "data-name": "Path 11863",
    d: "M32.261,15.381l-3.295-2.2a1.093,1.093,0,0,0-.957-.128l-2.947.982-2.947-.982a1.1,1.1,0,0,0-.839.06l-.607.3v6.17a2.214,2.214,0,0,1-.232.982l-1.1,2.2a2.2,2.2,0,0,1-3.928,0l-1.1-2.2a2.214,2.214,0,0,1-.232-.982v-6.17l-.607-.3a1.106,1.106,0,0,0-.839-.06l-2.862.954-1.79-.895a1.1,1.1,0,0,0-.982,0l-4.393,2.2A1.1,1.1,0,0,0,2,16.295a15.375,15.375,0,0,0,30.75,0A1.1,1.1,0,0,0,32.261,15.381Zm-24.772.914H7.5a1.1,1.1,0,1,1-.012,0ZM4.194,20.688a1.1,1.1,0,0,1,0-2.2h.012a1.1,1.1,0,0,1-.012,2.2Zm3.295,2.2a1.1,1.1,0,0,1,0-2.2H7.5a1.1,1.1,0,0,1-.012,2.2Zm2.2,5.491a1.1,1.1,0,0,1-.012-2.2H9.69a1.1,1.1,0,0,1,0,2.2ZM9.685,25.08a1.1,1.1,0,0,1,0-2.2H9.7a1.1,1.1,0,0,1-.012,2.2Zm0-4.393a1.1,1.1,0,0,1,0-2.2H9.7a1.1,1.1,0,0,1-.012,2.2Zm1.1-3.295a1.1,1.1,0,0,1,1.1-1.1h.012a1.1,1.1,0,1,1-1.107,1.1ZM16.249,28a.549.549,0,0,1-.695.347l-3.295-1.1a.549.549,0,1,1,.347-1.041l3.295,1.1A.549.549,0,0,1,16.249,28Zm-.133-1.982a.549.549,0,0,1-.776,0l-3.295-3.295a.549.549,0,0,1,.776-.776l3.295,3.295A.549.549,0,0,1,16.116,26.018Zm8.937-7.527h.012a1.095,1.095,0,1,1-.012,0Zm-2.562,8.757-3.295,1.1a.549.549,0,1,1-.347-1.041l3.295-1.1a.549.549,0,1,1,.347,1.041Zm.215-4.525-3.295,3.295a.549.549,0,0,1-.776-.776l3.295-3.295a.549.549,0,0,1,.776.776Zm.163-4.232a1.1,1.1,0,0,1-.012-2.2h.012a1.1,1.1,0,0,1,0,2.2Zm2.2,9.884a1.1,1.1,0,0,1-.012-2.2h.012a1.1,1.1,0,0,1,0,2.2Zm0-3.295a1.1,1.1,0,0,1-.012-2.2h.012a1.1,1.1,0,0,1,0,2.2Zm2.2-2.2a1.1,1.1,0,0,1-.012-2.2h.012a1.1,1.1,0,0,1,0,2.2Zm0-4.393a1.1,1.1,0,0,1-.012-2.2h.012a1.1,1.1,0,0,1,0,2.2Zm3.295,2.2a1.1,1.1,0,0,1-.012-2.2h.012a1.1,1.1,0,0,1,0,2.2Z",
    transform: "translate(0 1.08)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeotechnicalMaterialsIcon);
export default __webpack_public_path__ + "static/media/Geotechnical_Materials_icon.5c066f5ab67db60440b30f7bbfadcd8b.svg";
export { ForwardRef as ReactComponent };